import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 43"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#004EEB",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M12.5 35.5v4.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109H7.1c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5.5 40.74 5.5 40.46 5.5 39.9v-4.4m28 0v4.4c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437c-.214.109-.494.109-1.054.109h-3.8c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.214-.109-.494-.109-1.054v-4.4m-25-14h36m-36-13h36m-29 20h3m16 0h3m-19.4 7h16.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622c.654-1.283.654-2.964.654-6.324V11.1c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C32.94 1.5 31.26 1.5 27.9 1.5H11.1c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C1.5 6.06 1.5 7.74 1.5 11.1v14.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622c1.284.654 2.964.654 6.324.654Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "bus"}) } }